module.exports = __webpack_public_path__ + "img/product-shot_04_loading.934241c1.jpg";